var exports = {
  "kL": "container__hA66Yj",
  "Pf": "label__WIqKRJ",
  "DD": "title__z7VTxw",
};

module.exports = exports;
